module.exports = __webpack_public_path__ + "eb4a1ce88c5458eba463abdc27a20f22.MP3";